const genderList = [
    {value: 'М', label: 'Мужской'},
    {value: 'Ж', label: 'Женский'},
]

export default genderList
